import { make } from 'vuex-pathify'
import { util } from 'pevueglobal'

// state
const state = () => ({
  metaData: {},
  metaConfig: [
    {
      infoRequiredName: 'TblActJudgementInfoRequired',
      infoRequiredID: 0,
      infoRequiredTableName: 'TblActJudgementInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblBookFormMetaInfoRequired',
      infoRequiredID: 1,
      infoRequiredTableName: 'TblBookFormMetaInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblCategoryInfoRequired',
      infoRequiredID: 2,
      infoRequiredTableName: 'TblCategoryInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblCourseAttendanceInfoRequired',
      infoRequiredID: 3,
      infoRequiredTableName: 'TblCourseAttendanceInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblDossierInfoRequired',
      infoRequiredID: 4,
      infoRequiredTableName: 'TblDossierInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblDossierJudgementInfoRequired',
      infoRequiredID: 5,
      infoRequiredTableName: 'TblDossierJudgementInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblEduInfoRequired',
      infoRequiredID: 6,
      infoRequiredTableName: 'TblEduInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblExternalOrganizationInfoRequired',
      infoRequiredID: 7,
      infoRequiredTableName: 'TblExternalOrganizationInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblJudgementInfoRequired',
      infoRequiredID: 8,
      infoRequiredTableName: 'TblJudgementInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblPersonInfoRequired',
      infoRequiredID: 9,
      infoRequiredTableName: 'TblPersonInfoRequired',
      loaded: false
    },

    {
      infoRequiredName: 'TblInstituteForSchemeInfoRequired',
      infoRequiredID: 10,
      infoRequiredTableName: 'TblInstituteForSchemeInfoRequired',
      loaded: false
    }
  ],
  validated: false // indicator die aangeeft of dat er al een validatie heeft plaatsgevonden, initieel of na submit
})

const mutations = {
  ...make.mutations(state),
  setMetaData(state, { metaData, metaDataPossibleValues, infoRequired }) {
    // dynamische mutatie functie om rij te updaten, de functie spreek je aan met een row id en dit levert een nieuwe functie op dat de echte mutatie is, deze geef je mee aan de XVmetadatarow  mutation prop

    // Defaultwaardes setten
    // metaData.forEach(mcs => {
    //   if (mcs.metaveldDefaultValue !== null && (mcs.metaveldValue === null || mcs.metaveldValue === '')) {
    //     mcs.metaveldValue = mcs.metaveldDefaultValue
    //   }
    // })
    metaData.forEach(mcs => {
      if (mcs.metaveldValue === null || mcs.metaveldValue === '') {
        mcs.metaveldValue = mcs.metaveldDefaultValue || ''
      }
    })

    // filter enkele
    let meta = metaData.filter(
      md =>
        md.metaveldFieldTypeID !== 5 &&
        md.metaveldFieldTypeID !== 6 &&
        md.metaveldFieldTypeID !== 10 &&
        md.metaveldFieldTypeID !== 11
    )

    // filter multi choice
    let metaMultiChoice = metaData.filter(
      md =>
        md.metaveldFieldTypeID === 5 ||
        md.metaveldFieldTypeID === 6 ||
        md.metaveldFieldTypeID === 10 ||
        md.metaveldFieldTypeID === 11
    )

    // voor elke multichoice
    metaMultiChoice.forEach(mcs => {
      // haal alle rijen van multichoice

      // set de waarde van multichoice, komma gescheiden naar array met int (ID)

      if (mcs.metaveldValue !== null && mcs.metaveldValue !== '') {
        if (mcs.metaveldFieldTypeID === 6) {
          // de multiselect verwacht als waarde een array in zelfde structuur als possibleValues
          let waardes = mcs.metaveldValue.split(',').map(v => parseInt(v))

          mcs.metaveldValue = waardes.map(w => {
            let posval = metaDataPossibleValues.filter(
              f => f.infoRequiredID === mcs.metaveldtableID && w === f.infoRequiredPossibleValueID
            )

            return { value: posval[0].infoRequiredPossibleValueID, labelText: posval[0].textLabel }
          })

          // console.log(mcs.metaveldValue)
        } else {
          mcs.metaveldValue = mcs.metaveldValue.split(',').map(v => parseInt(v))
        }
      } else {
        mcs.metaveldValue = []
      }

      // zet alle mogelijke waarden in array (ID,label)
      mcs.possibleValues = metaDataPossibleValues
        .filter(f => f.infoRequiredID === mcs.metaveldtableID)
        .map(mdpv => {
          return {
            value: mdpv.infoRequiredPossibleValueID,
            labelText: mdpv.textLabel,
            sortorder: mdpv.infoRequiredPossibleValueSequenceNumber
          }
        })
      let sorttype = metaDataPossibleValues.filter(f => f.infoRequiredID === mcs.metaveldtableID)[0].sorttype

      if (sorttype === 1) {
        mcs.possibleValues.sort((a, b) => {
          if (a.labelText < b.labelText) {
            return -1
          }
          if (a.labelText > b.labelText) {
            return 1
          }
          return 0
        })
      } else {
        mcs.possibleValues.sort((a, b) => {
          if (a.sortorder < b.sortorder) {
            return -1
          }
          if (a.sortorder > b.sortorder) {
            return 1
          }
          return 0
        })
      }

      // fmcs.forEach((mcs, index) => {
      //   metamultirow.possibleValues.push({ value: mcs.posValueID, labelText: mcs.posValueName })
      // })
    })

    // Convert Dates
    meta
      .filter(md => md.metaveldFieldTypeID === 1)
      .forEach(md => {
        if (md.metaveldDateValue !== null) {
          md.metaveldValue = new Date(md.metaveldDateValue)
        } else {
          md.metaveldValue = null
        }

        return md
      })

    // Convert Files
    meta
      .filter(md => md.metaveldFieldTypeID === 9)
      .forEach(md => {
        if (md.metaveldValue !== null && md.metaveldValue !== '') {
          let filearray = []
          md.metaveldValue.split(';').forEach(v => {
            if (v !== '') {
              filearray.push({ uploadFileID: parseInt(v), error: false })
            }
          })

          md.metaveldValue = filearray
        } else {
          md.metaveldValue = []
        }

        return md
      })
    // state.metaData[metaConfig.infoRequiredName] = meta.sort(
    //   (a, b) => a.metaveldOrder - b.metaveldOrder
    // )
    // if (
    //   state.metaConfig.findIndex(
    //     mc => mc.infoRequiredID === metaConfig.infoRequiredID
    //   ) === -1
    // ) {
    //   state.metaConfig.push(metaConfig)
    // }

    // state.metaData = metaData.map(md => {
    //   if (md.metaveldFieldTypeID === 6 || md.metaveldFieldTypeID === 10) {
    //     md.metaveldValue = md.metaveldValue.split(',')
    //     console.log(md)
    //   }
    // })

    state.metaData[infoRequired.infoRequiredName] = [...meta, ...metaMultiChoice].sort(
      (a, b) => a.metaveldOrder - b.metaveldOrder
    )

    if (state.metaData[infoRequired.infoRequiredName].length !== 0) {
      infoRequired.loaded = true
    }
  }
}

const getters = {
  // MetaData: state => infoRequiredName => state.metaData[infoRequiredName],
  MetaDatarow: state => (rowID, infoRequiredName) => state.metaData[infoRequiredName][rowID],
  MetaDatarowvalue: state => (rowID, infoRequiredName) =>
    state.metaData[infoRequiredName].filter(row => row.metaveldtableID === rowID)[0].metaveldValue,
  AllValid: state => infoRequiredName =>
    state.metaData[infoRequiredName].reduce((valid, row) => (valid = valid && !row.haserror), true), // check of all metaveld validators ok geven
  getMetaDataConfig: state => ({ infoRequiredName }) =>
    state.metaConfig.find(mc => mc.infoRequiredName === infoRequiredName),
  GetSaveMetaData: state => ({ infoRequiredName }) => {
    let metaConfig = state.metaConfig.find(mc => mc.infoRequiredName === infoRequiredName)

    let metainput = state.metaData[infoRequiredName].map(r => {
      // multichoice Dropdown, checkbox
      if (r.metaveldFieldTypeID === 6) {
        // console.log(r.metaveldValue)
        if (r.metaveldValue === '') {
          return {
            fieldID: r.metaveldtableID,
            fieldValue: '',
            fieldDateValue: null,
            fieldValueArray: null
          }
        } else {
          // return {
          //   fieldID: r.metaveldtableID,
          //   fieldValue: '',
          //   fieldDateValue: null,
          //   fieldValueArray: null
          // }
          let multiselectSaveWaarde = r.metaveldValue.map(v => {
            return v.value
          }) // naar komma gescheiden voor DB
          return {
            fieldID: r.metaveldtableID,
            fieldValue: multiselectSaveWaarde.toString(),
            fieldDateValue: null,
            fieldValueArray: null
          }
        }
      } else if (r.metaveldFieldTypeID === 10) {
        return {
          fieldID: r.metaveldtableID,
          fieldValue: r.metaveldValue.toString(),
          fieldDateValue: null,
          fieldValueArray: null
        }
      } else if (r.metaveldFieldTypeID === 9) {
        // bestanden
        return {
          fieldID: r.metaveldtableID,
          fieldValue: r.metaveldValue.map(b => b.uploadFileID)
            .toString()
            .replace(',', ';'), // bestanden worden opgeslagen met een ; i.p.v. puntkomma
          fieldDateValue: null,
          fieldValueArray: null
        }
      } else if (r.metaveldFieldTypeID === 1 || r.metaveldFieldTypeID === 2) {
        // date en datetime
        return {
          fieldID: r.metaveldtableID,
          fieldValue: null,
          fieldDateValue: util.DateForDatabase(r.metaveldValue),
          fieldValueArray: null
        }
      } else if (r.metaveldFieldTypeID === 5 || r.metaveldFieldTypeID === 11) {
        return {
          fieldID: r.metaveldtableID,
          fieldValue: r.metaveldValue === null ? null : r.metaveldValue.toString(),
          fieldDateValue: null,
          fieldValueArray: null
        }
      } else {
        return {
          fieldID: r.metaveldtableID,
          fieldValue: r.metaveldValue,
          fieldDateValue: null,
          fieldValueArray: null
        }
      }
    })
    return { metainput, infoRequiredTable: metaConfig.infoRequiredID }
  }
}

const actions = {
  getMetaData: async ({ state, commit, getters }, { infoRequiredName, parameters = [], ...postData }) => {
    // haal eerst pagina data op en daarna pas tabel en graphcontrol
    let conf = getters.getMetaDataConfig({ infoRequiredName })
    conf.loaded = false

    const isLoggedIn = await util.isLoggedIn()

    util
      .getDataApi(`${isLoggedIn ? 'allroles/PEapi_metadata' : 'public/PEapi_metadata_definition/'}`, {
        infoRequiredTable: conf.infoRequiredID,
        parameters,
        ...postData
      })
      .then(async data => {
        data.infoRequired = conf

        commit('setMetaData', data)
      })
  }
  //   saveMetaData: async ({ state, getters }, { infoRequiredName, parameters = [] }) => {
  //     let metaConfig = getters.getMetaDataConfig({ infoRequiredName })

  //     let metainput = state.metaData[infoRequiredName].map(r => {
  //       // multichoice Dropdown, checkbox
  //       if (r.metaveldFieldTypeID === 6 || r.metaveldFieldTypeID === 10) {
  //         return {
  //           fieldID: r.metaveldtableID,
  //           fieldValue: r.metaveldValue.toString(),
  //           fieldDateValue: null,
  //           fieldValueArray: null
  //         }
  //       } else if (r.metaveldFieldTypeID === 9) {
  //         // bestanden
  //         return {
  //           fieldID: r.metaveldtableID,
  //           fieldValue: r.metaveldValue.map(b => b.uploadFileID).toString(),
  //           fieldDateValue: null,
  //           fieldValueArray: null
  //         }
  //       } else if (r.metaveldFieldTypeID === 1 || r.metaveldFieldTypeID === 2) {
  //         // date en datetime
  //         return {
  //           fieldID: r.metaveldtableID,
  //           fieldValue: null,
  //           fieldDateValue: util.DateForDatabase(r.metaveldDateValue),
  //           fieldValueArray: null
  //         }
  //       } else if (r.metaveldFieldTypeID === 5 || r.metaveldFieldTypeID === 11) {
  //         return {
  //           fieldID: r.metaveldtableID,
  //           fieldValue: r.metaveldValue === null ? null : r.metaveldValue[0],
  //           fieldDateValue: null,
  //           fieldValueArray: null
  //         }
  //       } else {
  //         return {
  //           fieldID: r.metaveldtableID,
  //           fieldValue: r.metaveldValue,
  //           fieldDateValue: null,
  //           fieldValueArray: null
  //         }
  //       }
  //     })

  //     // haal eerst pagina data op en daarna pas tabel en graphcontrol
  //     util
  //       .getDataApi('allroles/PEapi_savemetadata/', {
  //         metainput,
  //         infoRequiredTable: metaConfig.infoRequiredID,
  //         parameters
  //       })
  //       .then(async data => {})
  //   }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

// metaveldModifyType = b.v. TblPersonInfoRequiredModify
// Code die aangeeft of het veld door de gebruiker te wijzigen is op het scherm.dit is b.v.nodig als de gegevens geimporteerd worden uit een ander systeem met een dagelijkse import.
// 1 - Veld tonen / niet wijzigen
// 2 - Veld tonen(default ) / wijzigbaar / nietverplicht
// 3 - Velden tonen / Wijzigbaar verplicht
// 4 - Niet tonen

// metaveldFieldTypeID is TblCustomAddedFieldTypeID
// id	name
// 1	Datum
// 2	Datum / tijd
// 3	Getal
// 4	Tekst vrij invulbaar
// 5	Tekst Drop Down Box één keuze
// 6	Tekst Drop Down Box meerdere keuzes (multiselect)
// 7	Memo
// 8	E - mailadres
// 9	Bestand(en)
// 10	Checkboxes
// 11	Radiobuttons
// 12	URL

// object wat binnnekomt heeft rijen met deze struktuut
//    {
//       metaveldtableID: null,
//       metaveldModifyType: null,
//       metaveldFieldTypeID: null,
//       metaveldLabel: null,
//       metaveldHelptext: null,
//       metaveldValueLabels: null,
//       metaveldValue: null,
//       metaveldHorizontaal: null,
//       metaveldHeaderVisible: null,
//       metaveldAantalDecimalen: null,
//       metaveldOrder: null
//     }

// originele query SELECT DISTINCT ID, value, sequence, textID, TblCustomAddedFieldTypeID, helpTextID, dbo.getUserTranslation(7, 7, textID) AS metaname, dbo.getUserTranslation(7, 7, helpTextID) AS helptext, dbo.getUserTranslation(7, 7, posValueNaamID) AS posValueName, posValueNaamID, posValueID, posValueSequence, sortOrder, showHorizontal, showHeader, amountFiles, maxFileSize, aantalDec, req, height, width, stored_proc_pos_values, dbo.getUserTranslation(7, 7, TblPersonInfoRequiredHeaderTextId) AS headerText, customVal, posValueDateInactive FROM vwPersonInfoReq2 WHERE tblPersonID = 52519 AND TblProfGroupID = 55 AND req <> 4 ORDER BY sequence
